import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { TOKEN_KEY } from '@core/config/constants';

export const baseApi = createApi({
  reducerPath: 'baseApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/',
    prepareHeaders: (headers) => {
      const token = localStorage.getItem(TOKEN_KEY);
      if (token) {
        // useLocalStorage (usehooks-ts) stocke le token sérialisé en JSON
        try {
          const parsedToken = JSON.parse(token);
          headers.set('authorization', `Bearer ${parsedToken}`);
        } catch (_e) {
          headers.set('authorization', `Bearer ${token}`);
        }
      }
      return headers;
    },
  }),
  tagTypes: [
    'pickingListCampaign',
    'pickingScenarioList',
    'pickingFamilyScenarioList',
    'pickingLocationList',
    'customizationSessionList',
    'customizationSession',
    'customizationSessionOptions',
    'familyDemand',
    'workshopReleasable',
  ],
  endpoints: () => ({}),
});
